import { render, staticRenderFns } from "./ConfigurationItem.vue?vue&type=template&id=4f196428&scoped=true&"
import script from "./ConfigurationItem.vue?vue&type=script&lang=ts&"
export * from "./ConfigurationItem.vue?vue&type=script&lang=ts&"
import style0 from "./ConfigurationItem.vue?vue&type=style&index=0&id=4f196428&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f196428",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VImg } from 'vuetify/lib/components/VImg';
import { VLabel } from 'vuetify/lib/components/VLabel';
installComponents(component, {VAvatar,VImg,VLabel})
